import React, { useCallback, memo } from 'react';
import { SelectOption } from '@leasequery/lq.react-component-library/dist/models';
import { ReportCurrency } from '../../../../models';
import DateRange, { DateRangeLabel } from '../date-range/DateRange';

interface ReportSettingPercentageRentProps {
  onChange: (updatedValue: ReportSettingPercentageRentState) => void;
  reportSettingState: ReportSettingPercentageRentState;
}

export interface ReportSettingPercentageRentState {
  selectedCurrency: SelectOption<ReportCurrency>;
  fromDate: string;
  toDate: string;
  isValid: boolean;
}

function ReportDateSettingPercentageRent({
  onChange,
  reportSettingState,
}: ReportSettingPercentageRentProps): JSX.Element {
  const dateRangeLabel: DateRangeLabel = { Start: 'From', End: 'To' };

  return (
    <>
      <DateRange
        onChange={useCallback(
          (fromDate: string, toDate: string, isValid: boolean): void => {
            onChange({
              ...reportSettingState,
              fromDate,
              toDate,
              isValid,
            });
          },
          [onChange, reportSettingState],
        )}
        startDate={reportSettingState.fromDate}
        endDate={reportSettingState.toDate}
        dateRangeLabel={dateRangeLabel}
      />
    </>
  );
}

export default memo(ReportDateSettingPercentageRent);
